// extracted by mini-css-extract-plugin
export var cartIcon = "_pc-0";
export var cartIconContainer = "_pc-1";